export default function Footer() {
  const scrollToSection = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <span className="text-xl font-heading text-white block mb-3">吃瓜网51</span>
            <p className="text-xs md:text-sm text-white/55 leading-relaxed">
              国内领先的娱乐<strong className="text-white/70">黑料</strong>聚合平台，每日更新最新<strong className="text-white/70">八卦新闻</strong>与<strong className="text-white/70">内幕消息</strong>，<strong className="text-white/70">爆料事件</strong>最先知道。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-3">快速导航</h4>
            <ul className="space-y-2">
              {[
                { label: '焦点爆料', href: '#carousel' },
                { label: '爆料合集', href: '#index' },
                { label: '深度爆料', href: '#cards' },
                { label: '热度榜单', href: '#ranking' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); scrollToSection(item.href); }}
                    className="text-xs md:text-sm text-white/55 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-3">关于我们</h4>
            <ul className="space-y-2">
              {[
                { label: '关于吃瓜网', href: '#about' },
                { label: '投稿爆料', href: '#contact' },
                { label: '常见问答', href: '#faq' },
                { label: 'APP下载', href: '#app' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); scrollToSection(item.href); }}
                    className="text-xs md:text-sm text-white/55 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-3">合作伙伴</h4>
            <p className="text-xs md:text-sm text-white/40 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/35">
            &copy; 2020-2026 吃瓜网51 版权所有 | 爆料黑料专区
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-white/35 cursor-pointer hover:text-white/55 transition-colors whitespace-nowrap">用户协议</span>
            <span className="text-xs text-white/35 cursor-pointer hover:text-white/55 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-white/35 cursor-pointer hover:text-white/55 transition-colors whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}